import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

export function CancelHotelBooking({
  open,
  closeDrawer,
}: {
  open: boolean;
  closeDrawer: () => void;
}) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <ConfirmDrawer
      open={open}
      onClose={closeDrawer}
      onConfirm={() => {
        navigate({ to: "/" });
      }}
      title={intl.formatMessage({ id: "hotels.cancelBooking" })}
      description={intl.formatMessage({ id: "hotels.cancelBookingDesc" })}
      closeLabel={intl.formatMessage({ id: "back" })}
      confirmLabel={intl.formatMessage({ id: "cancel" })}
    />
  );
}
